import { StateCreator } from 'zustand';
import { IKamFlagData, TKamFlags } from './kameleoonFlags.interface';

export const kamFlagDataSlice: StateCreator<IKamFlagData> = (set) => ({
  kamFlags: {},
  setKamFlags(data: TKamFlags | null) {
    set(() => ({ kamFlags: data }));
  },
});
